/**
 * disciplineToSportProfile — canonical mapping from any discipline
 * synonym to the four sport-profile destinations.
 *
 * Phase E (system-sync) — extracted from ProfilePage SHORTCUT_MAP +
 * WorkoutDetailPage inline SPORT_MAP. Single source of truth for any
 * chip / button / Link that needs to navigate to /sport-profile/${target}.
 *
 * Returns null when the discipline doesn't have a sport-profile page
 * (strength / hyrox / other / mobility). Callers should fall back to
 * a plain text label in that case.
 */

export type SportProfileTarget = "run" | "bike" | "swim" | "triathlon";

const SHORTCUT_MAP: Record<string, SportProfileTarget> = {
  // Run family
  run: "run",
  running: "run",
  trail: "run",
  trailrun: "run",
  ultra: "run",

  // Bike family
  bike: "bike",
  biking: "bike",
  cycling: "bike",
  cycle: "bike",
  ride: "bike",
  gravel: "bike",
  mtb: "bike",

  // Swim family
  swim: "swim",
  swimming: "swim",
  pool: "swim",
  ows: "swim",
  openwater: "swim",
  "open-water": "swim",

  // Multisport
  triathlon: "triathlon",
  tri: "triathlon",
  duathlon: "triathlon",
  aquabike: "triathlon",
};

export function disciplineToSportProfile(
  discipline: string | null | undefined,
): SportProfileTarget | null {
  if (!discipline) return null;
  return SHORTCUT_MAP[discipline.toLowerCase()] ?? null;
}
